import axios from 'axios'

/**
 * Cliente do auto-cadastro de parceiros (wizard público /cadastro).
 *
 * Não usa os serviços de `services/api` de propósito: todos herdam de `Rest`,
 * cujo interceptor anexa o token da sessão logada e, em QUALQUER 401, apaga o
 * `userInfo` e redireciona para /login — o que destruiria um wizard anônimo no
 * meio do preenchimento. Mesmo racional do influencer/Apply.vue.
 *
 * A sessão do wizard é o token de retomada, enviado no header
 * `X-Onboarding-Token` (nunca em query string: query de API para em access log
 * de nginx; no navegador o token vive atrás do `#`, que nem chega ao servidor).
 */

const API = `${process.env.VUE_APP_API_BASE_URL}/api/v1/onboarding`

const tokenHeaders = token => ({ 'X-Onboarding-Token': token })

export function startLead(payload) {
  return axios.post(`${API}/leads`, payload)
}

export function fetchLead(token) {
  return axios.get(`${API}/leads/current`, { headers: tokenHeaders(token) })
}

export function saveStep(token, body) {
  return axios.patch(`${API}/leads/current`, body, { headers: tokenHeaders(token) })
}

export function submitLead(token, body) {
  return axios.post(`${API}/leads/current/submit`, body, { headers: tokenHeaders(token) })
}

export function resendLink(email, recaptchaToken) {
  return axios.post(`${API}/leads/resend`, { email, recaptcha_token: recaptchaToken })
}

/** Cidades de corp.cities — por código IBGE (vindo do ViaCEP) ou por nome + UF. */
export function searchCities(params) {
  return axios.get(`${API}/cities`, { params })
}

/**
 * ViaCEP direto do navegador (API pública, sem chave). Devolve `ibge`, que a
 * busca acima converte em `city_id` — o backend só aceita cidade do domínio.
 */
export function lookupCep(cep) {
  const digits = String(cep || '').replace(/\D/g, '')
  return axios.get(`https://viacep.com.br/ws/${digits}/json/`, { timeout: 6000 })
}

/**
 * `messages` do backend é uma string com JSON dentro (convenção do
 * NotificationException) — precisa de dois parses. `errors` é o bag padrão de
 * validação do Laravel.
 */
export function extractMessage(error, fallback) {
  const data = error && error.response && error.response.data
  if (data && data.messages) {
    try {
      const parsed = JSON.parse(data.messages)
      if (Array.isArray(parsed)) return parsed.join(' ')
    } catch (e) {
      return String(data.messages)
    }
  }
  if (data && data.errors) {
    return Object.values(data.errors).flat().join(' ')
  }
  return fallback
}

/** Bag de validação do Laravel → { campo: 'primeira mensagem' }. */
export function extractFieldErrors(error) {
  const errors = error && error.response && error.response.data && error.response.data.errors
  if (!errors) return {}

  return Object.keys(errors).reduce((out, field) => {
    const value = errors[field]
    out[field] = Array.isArray(value) ? value[0] : String(value)
    return out
  }, {})
}
